import axios from 'axios'

export interface AppInfo {
  version: number
  startTime: string
}

export const getAppInfo: () => Promise<AppInfo> = async () => {
  const response = await axios.get(`app/info`, {
    baseURL: process.env.REACT_APP_REST_API_URL,
  })
  return response.data
}
